export default "__VITE_ASSET__C9sU1CW1__"